module.exports = __webpack_public_path__ + "media/images/multibrands_banner-cbdb03b17ab5b90d1d94320b569490e1.png";